import { createSelector } from '@ngrx/store';
import { denormalize } from 'normalizr';
import {
  ByKey,
  createListStateIdsSelector,
  createListStateParamsSelector,
  createStateErrorsSelector,
  createStateLoadingSelector,
  createStateSuccessSelector,
  IdType,
  ListState
} from '@industi/ngx-common';
import { EntityTypes } from '../../../entity/entity-types';
import { createEntitiesSelector } from '../../../entity/entities.reducer';
import { createSymfonyTotalCountSelector } from '../../../symfony/list/selectors/list.selectors';
import { Entities } from '../../../entity/entities';
import { EntityState } from '../../../entity/entity.reducer';
import { getDictionaryMaterialExploitationListState } from '../material-exploitation.reducer';
import { DictionaryMaterialExploitation } from '../models/material-exploitation';

const createState = (id: IdType) => createSelector(
  getDictionaryMaterialExploitationListState,
  (state: ByKey<ListState>) => state && state[id]
);

const createStateByContext = (id: IdType) => createListStateIdsSelector(createState(id));

export const createDictionaryMaterialExploitationListData = (id: IdType) => createSelector(
  createStateByContext(id),
  createEntitiesSelector([
    EntityTypes.materialExploitation
  ]),
  (
    ids: IdType[],
    entities: EntityState
  ) => denormalize(ids, [Entities[EntityTypes.materialExploitation]], entities) as DictionaryMaterialExploitation[]
);

export const createDictionaryMaterialExploitationListLoading = (id: IdType) => createStateLoadingSelector(
  createState(id));

export const createDictionaryMaterialExploitationListSuccess = (id: IdType) => createStateSuccessSelector(
  createState(id));

export const createDictionaryMaterialExploitationListErrors = (id: IdType) => createStateErrorsSelector(
  createState(id));

export const createDictionaryMaterialExploitationListTotalCount = (id: IdType) => createSymfonyTotalCountSelector(
  createState(id));

export const createDictionaryMaterialExploitationListParams = (id: IdType) => createListStateParamsSelector(
  createState(id));
